const CustomTooltip = ({ active, payload, formatter }) => {
  const isVisible = active && payload && payload.length;
  console.log(payload, active, formatter);

  const initFormatter = value => {
    if (Number(value) !== Number.NaN) {
      return Number(value).toFixed(2);
    }
    return value;
  };
  return (
    <div
      className="rounded-md bg-white p-2"
      style={{ visibility: isVisible ? 'visible' : 'hidden' }}
    >
      {isVisible &&
        payload.map(item => {
          const label = item.payload?.label || item.name;
          return (
            <div key={item.name} className="flex items-center gap-2">
              <div
                className="h-2 w-2 rounded-sm"
                style={{
                  backgroundColor: item.payload?.color || item.payload?.fill || item.stroke
                }}
              ></div>
              <p>{`${label} : ${formatter ? formatter(item.value) : initFormatter(item.value)}`}</p>
            </div>
          );
        })}
    </div>
  );
};

export default CustomTooltip;
